module.exports = __webpack_public_path__ + "static/Schnyder-XL-Light-19b44a59ccb75de21590069123a0ff2f.otf";